"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const styled_components_1 = __importDefault(require("styled-components"));
const IconContainer_1 = __importStar(require("../IconContainer"));
const StyledPathOne = styled_components_1.default.path `
  fill: ${({ theme }) => theme.palette.primary.main};
`;
const StyledPathTwo = styled_components_1.default.path `
  fill: ${({ theme }) => theme.palette.red[50]};
`;
const NotificationIcon = ({ size = IconContainer_1.DEFAULT_ICON_SIZE, ...rest }) => ((0, jsx_runtime_1.jsxs)(IconContainer_1.StyledSvg, { fill: "none", height: size, viewBox: "0 0 24 24", width: size, xmlns: "http://www.w3.org/2000/svg", ...rest, children: [(0, jsx_runtime_1.jsx)(StyledPathOne, { d: "M11.75 16.238a2.875 2.875 0 012.875 2.875A2.886 2.886 0 0111.75 22a2.875 2.875 0 01-2.875-2.875c0-1.6 1.287-2.887 2.875-2.887z" }), (0, jsx_runtime_1.jsx)(StyledPathTwo, { d: "M4.671 17.737v-6.875c.013-3.925 3.292-7.1 7.329-7.1s7.316 3.175 7.316 7.1v6.875H4.67z" }), (0, jsx_runtime_1.jsx)(StyledPathTwo, { d: "M12 2c1.196 0 2.173.95 2.173 2.112 0 1.163-.977 2.113-2.173 2.113-1.196 0-2.173-.95-2.173-2.113C9.827 2.95 10.804 2 12 2zM19.251 15.687H4.75c-.965 0-1.749.763-1.749 1.7v1.8h18v-1.8c0-.937-.784-1.7-1.749-1.7z" })] }));
exports.default = (0, IconContainer_1.default)(NotificationIcon);
//# sourceMappingURL=index.js.map